import { useCallback } from 'react';

import { AppStateStatus } from 'react-native';

import { useUpdateOnAppStateChange } from 'hooks/use-update-on-app-state-change';

import { IGetPaymentMethodsOptions } from './types';

export const useAppStateRefresh = (
  getPaymentMethods: (options: IGetPaymentMethodsOptions) => Promise<void>,
  cognitoId: string | undefined
) => {
  const handleAppStateChange = useCallback(
    (appStateStatus: AppStateStatus) => {
      if (appStateStatus === 'active' && cognitoId) {
        getPaymentMethods({
          errorBehavior: 'log-only',
          source: 'app-state-active',
        });
      }
    },
    [getPaymentMethods, cognitoId]
  );

  useUpdateOnAppStateChange(handleAppStateChange);
};
